import MyStatistic from './MyStatistic';
export default MyStatistic;
